<template>
  <div class="ModalBody" ref="containerRef">
    <!-- <HeaderInfoTitle /> -->
    <div class="HeaderInfo" ref="headerRef" :class="{ 'HeaderInfo--stuck': isStuck }">
      <HeaderInfo></HeaderInfo>
      <BindPatientDoctor class="BindPatientDoctor" />
    </div>
    <div class="mind">
      <PatientPortrait
        class="item PatientPortrait"
        :uc-patient-id="info?.ucPatientId"
        :uc-doctor-id="doctorInfo?.ucDoctorId"
      />
      <MarkCooperate class="item MarkCooperate" />
      <UserTag class="item UserTag" />
    </div>
    <div class="tabs">
      <a-tabs :destroyInactiveTabPane="true" v-model:activeKey="activeKey">
        <a-tab-pane key="3" tab="服务记录">
          <PlatformService />
        </a-tab-pane>
        <a-tab-pane key="1" tab="病程记录">
          <RecordDisease @refresh="onFollowupSchedule" class=""></RecordDisease>
        </a-tab-pane>
        <a-tab-pane key="2" tab="全病程管理">
          <WholeCourse />
        </a-tab-pane>
        <template #tabBarExtraContent>
          <!-- 预注册患者不展示 -->
          <div class="rightExtra" v-if="patientType">
            <div class="treatment-item">
              <span v-if="treatmentOBJ?.reserveDate" class="treatmentText">
                {{ treatmentText }}
              </span>
              <a-button @click="openTreatmentRef" size="mini" type="primary">
                <template #icon><CalendarOutlined /></template>
                查看复诊日程表
              </a-button>
            </div>
          </div>
        </template>
      </a-tabs>
    </div>
    <!-- 修改复诊日期弹窗 -->
    <SetRetreatment ref="treatmentRef" :isSheet="true" @changeReverseDate="onFollowupSchedule" />
  </div>
</template>

<script setup>
import SetRetreatment from '@/views/WorkPlace/Container/chat/components/retreatment/setRetreatment.vue'
import RecordDisease from './tags/RecordDisease/index.vue'
import WholeCourse from './tags/WholeCourse/index.vue'
import PlatformService from './tags/PlatformService/index.vue'
import { CalendarOutlined } from '@ant-design/icons-vue'
import { ref, computed, watch } from 'vue'
import HeaderInfo from './top/HeaderInfo.vue'
import BindPatientDoctor from './top/BindPatientDoctor.vue'
import MarkCooperate from './bottom/MarkCooperate.vue'
import UserTag from './bottom/UserTag.vue'
import PatientPortrait from './bottom/PatientPortrait.vue'
import { useUIHooks } from './hooksUI.js'
import { useStore } from 'vuex'
import { queryCureUnLimitRecently } from '@/api/patientFile'
import config from '@/config/index.js'
// import HeaderInfoTitle from './top/HeaderInfoTitle.vue'
import moment from 'moment'

const store = useStore()
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)

const activeKey = ref('3')
const { isStuck, headerRef, containerRef } = useUIHooks()
const treatmentRef = ref()
const treatmentOBJ = ref({})

// 计算治疗信息
const treatmentText = computed(() => {
  const { reserveDate, reserveDateDetail, week, revisitType, reserveState } = treatmentOBJ.value
  const datePart = moment(reserveDate).format('YYYY-MM-DD')
  const periodPart = reserveDateDetail ? (reserveDateDetail === 1 ? '上午' : '下午') : '未设置'
  const visitTypePart = revisitType === 1 ? '线上问诊' : '线下就诊'
  const statePart = config.RESERCE_STATE_MAP[reserveState]

  return `${datePart} ${week} ${periodPart}  ${visitTypePart} ${statePart}`
})
// 获取预约单ID
const onFollowupSchedule = () => {
  const ucDoctorId = doctorInfo.value.ucDoctorId
  const ucPatientId = info.value.ucPatientId
  const hasId = ucDoctorId && ucPatientId
  if (!hasId) return
  const params = {
    reserveStates: '3,5',
    ucDoctorId,
    ucPatientId
  }
  queryCureUnLimitRecently(params).then(result => {
    treatmentOBJ.value = result
  })
}
function openTreatmentRef() {
  const floatBusinessId = treatmentOBJ.value?.reserveId
  const userInfo = {
    ucPatientId: info.value.ucPatientId,
    ucDoctorId: doctorInfo.value.ucDoctorId,
    doctorId: doctorInfo.value.doctorId,
    patientId: info.value.patientId
  }
  treatmentRef.value.treatmentInit(null, floatBusinessId, userInfo)
}
watch(
  () => [info.value.ucPatientId, doctorInfo.value.ucDoctorId],
  () => {
    onFollowupSchedule()
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.ModalBody {
  background-color: #f3f3f3;
  padding: 0 24px 12px;
  overflow: hidden auto;
  height: 80vh;
  width: 100%;
  position: relative;
  .HeaderInfo {
    z-index: 3;
    transition: 0.1s;
    position: sticky;
    top: 12px;
    width: 100%;
    .BindPatientDoctor {
      margin-top: 12px;
    }
  }
  .HeaderInfo--stuck {
    top: 0px;
    margin-left: -24px;
    width: calc(100% + 48px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
    background-color: white;
  }
  .mind {
    margin-top: 1px;
    background-color: white;
    padding: 16px 24px;
    .item {
      margin-bottom: 14px;
      :last-child {
        margin-bottom: 0;
      }
    }
  }
  .tabs {
    margin-top: 16px;
    border-radius: 4px;

    ::v-deep(.ant-tabs) {
      overflow: inherit;
      .ant-tabs-bar {
        margin: 0;
        background-color: white;
        .ant-tabs-nav {
          .ant-tabs-tab {
            font-size: 16px;
            margin: 0;
            padding: 14px 32px;
          }
        }
      }
    }
    // tab右侧的扩展内容
    .rightExtra {
      margin-right: 16px;
      line-height: 52px;
      height: 52px;
      .treatment-item {
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #333;
        font-weight: 400;
        .treatmentText {
          position: relative;
          padding: 0 12px;
          &::before {
            position: absolute;
            content: '';
            width: 1px;
            height: 16px;
            background-color: #e8e8e8;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto 0;
          }
        }
      }
    }
  }
}
</style>
